// eslint-disable-next-line no-unused-vars
import React from 'react';
import { browserHistory } from '@americanexpress/one-app-router';
// eslint-disable-next-line no-unused-vars
import { ButtonPrimary, dlsColorWarning, IconWarning } from '@americanexpress/dls-react';
import { routes } from '../../constants/paths';

const Error404Page = () => {
  const onNavigation = () => {
    browserHistory.push({
      pathname: `${routes.home}`,
    });
  };

  return (
    <div className="border text-align-center pad-3-tb" role="alert">
      <div className="pad-responsive-lr stack">
        <IconWarning id="icon-warning" size="xl" theme={dlsColorWarning} />
        <h1 className="heading-4 margin-1-b">{'We\'re sorry, but we couldn\'t find this page.'}</h1>
        <p className="body-3">{'The web address you\'ve requested has either moved or no longer exists.'}</p>
      </div>
      <hr className="margin-3-tb" />
      <ButtonPrimary onClick={onNavigation}>Go to Account Home</ButtonPrimary>
    </div>
  );
};

export default Error404Page;
